import moment from 'moment';
import { AllocationMedium } from 'api/resource-management/types';
import {
  CompanyAllocationSummaryEvent,
  SchedulerEventType,
} from 'components/organisms/resource-management/event-types';
import { TeamAllocationSummary } from 'components/organisms/resource-management/types';
import { getDetailedAllocationData } from '../../common';
import {
  idForCompanyAllocationSummaryEvent,
  resourceIdForCompany,
} from '../../id';
import { getSchedulerEventProps, getSchedulerEventsClass } from '../common';

export const companyAllocationSummaryAsEvent = (
  companyId: number,
  allocationSummary: TeamAllocationSummary,
  softAllocationsEnabled?: boolean,
): CompanyAllocationSummaryEvent => {
  const { softAllocatedMinutes } = getDetailedAllocationData(
    allocationSummary.allocatedMinutes,
  );

  const softEventClass = `${
    softAllocatedMinutes > 0 ? `${AllocationMedium.Soft}`.toLowerCase() : ''
  }`;

  return {
    type: SchedulerEventType.CompanyAllocationSummary,
    id: idForCompanyAllocationSummaryEvent(
      companyId,
      allocationSummary.startDate,
      allocationSummary.forViewPreset,
    ),
    resourceId: resourceIdForCompany(companyId),
    startDate: moment(allocationSummary.startDate).startOf('day').toDate(),
    endDate: moment(allocationSummary.endDate).endOf('day').toDate(),
    allocatedMinutes: allocationSummary.allocatedMinutes,
    forViewPreset: allocationSummary.forViewPreset,
    ...getSchedulerEventProps(SchedulerEventType.CompanyAllocationSummary, {
      cls: getSchedulerEventsClass(
        SchedulerEventType.CompanyAllocationSummary,
        softAllocationsEnabled ? softEventClass : '',
      ),
    }),
  };
};
